module.exports = __webpack_public_path__ + "img/twitter-icon-bg.acdd48cdfc4fec4a3614bf1182ae3dc8.svg";